import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api_url } from '../constants/data';


function LegalDocuments() {
    const navigate = useNavigate();
    const [reports, setReports] = useState([])
    const token = localStorage.getItem('auth_token')
    
    useEffect(() => {
        axios.post(`${api_url}/legal-documents`, {}, {headers: { 'Authorization': 'Bearer ' + token}}).then(res => {
           
            setReports([...res.data])
        }).catch(err => {
            console.error(err.response.data.error)
        })
    }, [])

    const handleViewReportsClick = (report) => {
        navigate('/ReportInner', { state: { report} }); // Pass both report and index
      };
    
    return (
        <div className='viewreports'>
            <h1>Legal document list List</h1>
            <div className="reports-header">
                <h4>File</h4>
                <h4>Date</h4>
            </div>
            <div className="viewreports-inner">
                {
                    reports.map((reportdata) => (
                        <div className='reportitem' key={reportdata.id}>
                            <p><a href={reportdata.file} download target='_blank'>{reportdata.title}</a> </p>
                            <p>{reportdata.created_at.replace('T', ' ').substring(0, 16)}</p>
                        </div>
                    ))
                }


            </div>
        </div>
    )
}

export default LegalDocuments